<template><span class="site-icon" :style="iconStyle" aria-hidden="true"></span></template>
<script setup>
import { computed } from 'vue'
const props = defineProps({ name: { type:String, required:true }, size: { type:Number, default:20 } })
const iconStyle = computed(() => {
  const url = `${import.meta.env.BASE_URL}icons/phosphor/${props.name}.svg`
  return { width:`${props.size}px`, height:`${props.size}px`, maskImage:`url("${url}")`, WebkitMaskImage:`url("${url}")` }
})
</script>
<style scoped>
.site-icon { display:inline-block; flex:none; vertical-align:middle; background:currentColor; mask:center/contain no-repeat; -webkit-mask:center/contain no-repeat; }
</style>
